import type { ComboboxItem } from "@mantine/core";
import { Button, Select, Stack } from "@mantine/core";
import { FormFieldInfoText } from "../../../../../components/BuildingBlocks/Forms/MantineFormFields/FormFieldInfoText/FormFieldInfoText";
import { FormFieldLabel } from "../../../../../components/BuildingBlocks/Forms/MantineFormFields/FormFieldLabel";
import type { Paragraph6ContractPayload } from "../../../Paragraph6.types";

interface Paragraph6ContractTemplateSelectProps {
  templates?: Array<Paragraph6ContractPayload>;
  onChange: (template: Partial<Paragraph6ContractPayload> | null) => void;
}

function Paragraph6ContractTemplateSelect({
  templates,
  onChange
}: Paragraph6ContractTemplateSelectProps) {
  const templateItems =
    templates?.map((template): ComboboxItem => ({
      label: template.name,
      value: template.id
    })) || [];
  const showTemplateButtons = templateItems.length <= 6;

  function handleChange(value: string | null) {
    const template = templates?.find((template) => template.id === value);
    if (template) {
      onChange({
        ...template,
        is_template: false,
        name: "",
        id: undefined,
        gemeinde_anteile_erzeuger: []
      });
    }
  }

  return (
    <div className="contract-templates-list">
      <FormFieldLabel
        htmlFor={
          showTemplateButtons ? undefined : "Paragraph6ContractModal_template"
        }
        label="Referenzvertrag auswählen:"
      />
      {showTemplateButtons ? (
        <Stack gap={0}>
          {templateItems.map((template) => (
            <Button
              justify="flex-start"
              key={template.value}
              variant="subtle"
              onClick={() => handleChange(template.value)}
            >
              {template.label}
            </Button>
          ))}
        </Stack>
      ) : (
        <Select
          aria-label="Referenzvertrag auswählen"
          data={templateItems}
          id="Paragraph6ContractModal_template"
          onChange={handleChange}
        />
      )}
      <FormFieldInfoText infoText="Wählen Sie einen Referenzvertrag aus, um das Formular im nächsten Schritt vorauszufüllen." />
    </div>
  );
}
export { Paragraph6ContractTemplateSelect };
